import PropTypes from 'prop-types';

import { Tooltip } from '@codex/basics';
import styled from 'styled-components';

const StyledLink = styled.a`
  margin: 0;
  text-decoration: none;
  cursor: ${(props) => (props.linkDisabled ? 'default' : 'pointer')};
  color: ${(props) => (props.linkDisabled ? '#a9a9a9' : '#4855a0')};
`;


export default function LocationSearchErrorMessage(props) {

  return (
    <div className={'dc-location-search-error-message'}>
      <Tooltip textAlign={'center'} type={'negative'}>
        <span
              // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: `${props.errorMessageLabel} ` }}
        />
        <StyledLink
          href={'#try-again'}
          onClick={(e) => {
            e.preventDefault();
            if (props.linkDisabled) {
              e.stopPropagation();
            } else {
              props.onLinkClick(e);
            }
          }}
        >
          {props.linkLabel}
        </StyledLink>
      </Tooltip>
    </div>

  );
}

LocationSearchErrorMessage.propTypes = {
  errorMessageLabel: PropTypes.string.isRequired,
  linkLabel: PropTypes.string.isRequired,
  linkDisabled: PropTypes.bool.isRequired,
  onLinkClick: PropTypes.func.isRequired
};
